import {
    SIGNIN,
    SIGNIN_SUCCESS,
    SIGNIN_FAIL,

    CADASTRO,
    CADASTRO_SUCCESS,
    CADASTRO_FAIL,

    LOGIN_SIG,
    LOGIN_SIG_SUCCESS,
    LOGIN_SIG_FAIL,
    CADASTRO_USER,
} from './types'
import api from './api';
import { setCookie, deleteCookie, toastMessage } from '../utils/Utils'

export const logar = (data) => {
    return dispatch => {
        dispatch({ type:SIGNIN })

        let params = new FormData()
        for(let i in data){
            params.append(i,data[i])
        }

        api.post('auth', params).then( res => {
            res = res.data
            setCookie('assinaturaDigitalFinsol',`${res.jwt.type} ${res.jwt.token}`,1)
            localStorage.setItem('token',`${res.jwt.type} ${res.jwt.token}`)
            localStorage.setItem('user',JSON.stringify(res.user))

            dispatch({ type: SIGNIN_SUCCESS, payload:  `${res.jwt.type} ${res.jwt.token}` })
            window.location.href = '/documentos'
        }).catch( err => {
            err = err.response.data
            dispatch({ type: SIGNIN_FAIL, payload: err.message})
        })

    }
}

export const deslogar = () => {
    return dispatch => {
        localStorage.clear()
        deleteCookie('assinaturaDigitalFinsol')
        window.location.href = '/'
    }
}

export const cadastrar = (data) => {
    return dispatch => {
        dispatch({ type:CADASTRO })

        let params = new FormData()
        for(let i in data){
            params.append(i,data[i])
        }

        api.post('register', params).then( res => {
            res = res.data
           // console.log('cadastro',res)
            setCookie('assinaturaDigitalFinsol',`${res.jwt.type} ${res.jwt.token}`,1)
            localStorage.setItem('token',`${res.jwt.type} ${res.jwt.token}`)

            dispatch({ type: CADASTRO_SUCCESS, payload: `${res.jwt.type} ${res.jwt.token}`})
            window.location.href = '/documentos'
        }).catch( err => {
            err = err.response.data
            console.log('ERROR',err)
            dispatch({ type: CADASTRO_FAIL, payload: err.message})
        })

    }
}


export const logar_signatario = (dados) => {
    return dispatch => {
        dispatch({ type: LOGIN_SIG })

        let params = new FormData()
        for(let i in dados){
            params.append(i,dados[i])
        }

        api.post('signatario/auth', params).then( res => {
            res = res.data

            dispatch({ type: LOGIN_SIG_SUCCESS, payload: res.message})
 
        }).catch( err => {
            err = err.response.data
            console.log('ERROR',err)
            dispatch({ type: LOGIN_SIG_FAIL, payload: err.message})
        })

    }
}

export const cadastrarUser = (data, callback = () => null) => {
    return dispatch => {
        dispatch({ type: CADASTRO_USER, payload: { loading_auth: true, error_cadastro:false, msg_cadastroUser: '' } })

        let params = new FormData()
        for(let i in data){
            params.append(i,data[i])
        }

        api.post('user/register', params).then( res => {
            res = res.data
           // console.log('cadastro',res)
           var payload = { 
                loading_auth: false,
                msg_cadastroUser: res.message,
                error_cadastro: false
            }
            dispatch({ type: CADASTRO_USER, payload })
            callback(true)

        }).catch( err => {
            err = err.response.data
            console.log('ERROR',err)
            var payload = { 
                loading_auth: false,
                msg_cadastroUser: err.message,
                error_cadastro: true
            }

            dispatch({ type: CADASTRO_USER, payload })
            callback(false)
        })

    }
}

export const UpdateUser = (data, callback = () => null) => {
    return dispatch => {
        dispatch({ type: CADASTRO_USER, payload: { loading_auth: true, error_cadastro:false, msg_cadastroUser: '' } })

        let params = new FormData()
        for(let i in data){
            params.append(i,data[i])
        }

        api.put('user', params).then( res => {
            res = res.data
           // console.log('cadastro',res)
           var payload = { 
                loading_auth: false,
                msg_cadastroUser: res.message,
                error_cadastro: false,
                userUpdate: undefined
            }
            dispatch({ type: CADASTRO_USER, payload })
            callback(true)

        }).catch( err => {
            err = err.response.data
            console.log('ERROR',err)
            var payload = { 
                loading_auth: false,
                msg_cadastroUser: err.message,
                error_cadastro: true,
                userUpdate: false
            }

            dispatch({ type: CADASTRO_USER, payload })
            toastMessage('error', err.message)
            callback(false)
        })

    }
}

export const addState = (payload) => {
    return dispatch => {
        dispatch({ type: CADASTRO_USER, payload})
    }
}